<template>
  <div class="haiyun-sap-warehouse-config">
    <el-form ref="form"
             :model="form"
             inline
             class="table-search-bar"
             label-width="150px">
      <el-form-item label="提货区域"
                    prop="takeAreaName">
        <el-select v-model="form.takeAreaName"
                   placeholder="请选择提货区域"
                   clearable
                   filterable>
          <el-option v-for="item in areaList"
                     :key="item.id"
                     :label="item.areaName"
                     :value="item.areaName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工厂编码"
                    prop="factoryCode">
        <el-input v-model="form.factoryCode"
                  placeholder="请输入工厂编码"
                  clearable
                  @keyup.enter.native="handleSearch">
        </el-input>
      </el-form-item>
      <el-form-item label="SAP库区编码"
                    prop="sapWarehouseAreaCode">
        <el-input v-model="form.sapWarehouseAreaCode"
                  placeholder="请输入SAP库区编码"
                  clearable
                  @keyup.enter.native="handleSearch">
        </el-input>
      </el-form-item>
      <el-form-item label="SAP库区名称"
                    prop="sapWarehouseAreaName">
        <el-input v-model="form.sapWarehouseAreaName"
                  placeholder="请输入SAP库区名称"
                  clearable
                  @keyup.enter.native="handleSearch">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="handleSearch">搜索</el-button>
        <el-button type="primary"
                   @click="add"
                   v-permission="'0061001'">新增</el-button>
        <el-button type="primary"
                   @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData"
              style="width: 100%"
              tooltip-effect="light">
      <el-table-column prop="takeAreaName"
                       label="提货区域"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="hyhnProcess"
                       label="业务归属"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          {{ getBusinessBelongingText(scope.row.hyhnProcess) }}
        </template>
      </el-table-column>
      <el-table-column prop="factoryCode"
                       label="工厂编码"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sapWarehouseAreaCode"
                       label="SAP库区编码"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sapWarehouseAreaName"
                       label="SAP库区名称"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="updatePerson"
                       label="操作人"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="updateTime"
                       label="操作时间"
                       show-overflow-tooltip
                       width="180px">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)"
                     v-permission="'0061002'">编辑</el-button>
          <el-button @click="deleteRow(scope.row)"
                     v-permission="'0061003'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination :page-sizes="[10, 20, 50, 100]"
                     :page-size="listState.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="listState.total"
                     :current-page="listState.pageNum"
                     background
                     @current-change="handleCurrentChange"
                     @size-change="handleSizeChange">
      </el-pagination>
      <div class="output-box">
        每页<el-select class="select-page"
                   v-model="pageSize"
                   placeholder="请选择条数">
          <el-option v-for="item in sizeArr"
                     :key="item.value"
                     :label="item.label"
                     :value="item.label">
          </el-option>
        </el-select>条
        第<el-select class="select-page"
                   v-model="pageNum"
                   placeholder="请输入页码">
          <el-option v-for="item in sizeNumber"
                     :key="item"
                     :label="item"
                     :value="item">
          </el-option>
        </el-select>页
        <el-button class="select-page-btn"
                   type="primary"
                   @click="handleExport()">导出文件</el-button>
      </div>
    </div>
    <add-or-edit-dialog :is-edit="isEdit"
                        :show.sync="addOrEditShow"
                        :info="addOrEditInfo"
                        :areaList="areaList"
                        @reloadTable="handleSearch"></add-or-edit-dialog>
  </div>
</template>

<script>
import addOrEditDialog from './addOrEditDialog.vue'
import HttpUtil from '@/common/HttpUtil'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'haiyunSapWarehouseConfig',
  components: { addOrEditDialog },
  data () {
    return {
      addOrEditShow: false,
      addOrEditInfo: {},
      form: {
        takeAreaName: '',
        factoryCode: '',
        sapWarehouseAreaCode: '',
        sapWarehouseAreaName: '',
        pageNum: 1,
        pageSize: 10
      },
      pageNum: 1,
      pageSize: 10,
      sizeArr: [
        { value: '', label: '100' },
        { value: 1, label: '500' },
        { value: 2, label: '1000' },
        { value: 3, label: '2000' }
      ],
      isEdit: false,
      areaList: []
    }
  },
  computed: {
    ...mapState('haiyunSapWarehouse', {
      tableData: state => state.list,
      listState: state => state.listState
    }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.pageSize) + 1
      const arr = [...new Array(maxNo).keys()]
      arr.shift()
      return arr
    }
  },
  async mounted () {
    console.log('海韵海南公司间结算SAP组件已加载')
    try {
      this.handleSearch()
      let params = {
        areaType: 2,
        localArea: 0
      }
      const res = await HttpUtil.post('manage/system/area/query/type', params)
      if (res.data) {
        this.areaList = res.data
      }
    } catch (error) {
      console.error('初始化数据加载失败:', error)
      this.$message.error('数据加载失败，请刷新页面重试')
    }
  },
  methods: {
    // 获取业务归属文字
    getBusinessBelongingText (value) {
      const businessBelongingMap = {
        1: '山东炼厂',
        2: '海南炼厂'
      }
      return businessBelongingMap[value] || value
    },
    ...mapActions('haiyunSapWarehouse', ['getHaiyunSapWarehouseList', 'deleteHaiyunSapWarehouse', 'addHaiyunSapWarehouse', 'updateHaiyunSapWarehouse', 'exportHaiyunSapWarehouse']),
    add () {
      this.addOrEditInfo = {}
      this.addOrEditShow = true
      this.isEdit = false
    },
    edit (row) {
      this.addOrEditInfo = row
      this.addOrEditShow = true
      this.isEdit = true
    },
    deleteRow (row) {
      this.$confirm('确定要删除这条记录吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteHaiyunSapWarehouse({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.handleSearch()
        }).catch(error => {
          console.error('删除失败:', error)
          this.$message.error('删除失败，请重试')
        })
      })
    },
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 搜索
    handleSearch (params) {
      const searchParams = {
        ...this.form,
        ...params
      }
      this.getHaiyunSapWarehouseList(searchParams)
        .catch(error => {
          console.error('获取数据失败:', error)
          this.$message.error('获取列表数据失败，请检查您的登录状态或者网络连接')
        })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getHaiyunSapWarehouseList({ pageNum: 1, pageSize: val })
        .catch(error => {
          console.error('分页查询失败:', error)
          this.$message.error('分页查询失败，请重试')
        })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getHaiyunSapWarehouseList({ pageNum: val })
        .catch(error => {
          console.error('分页查询失败:', error)
          this.$message.error('分页查询失败，请重试')
        })
    },
    // 导出数据
    handleExport () {
      if (!Array.isArray(this.tableData) || this.tableData.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }

      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const exportParams = {
          ...this.form,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.exportHaiyunSapWarehouse(exportParams).then((res) => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '海韵海南公司间间结算SAP库区配置表.xls'
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
        }).catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败，请重试')
        })
      }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.haiyun-sap-warehouse-config {
  padding: 20px;
}

.table-search-bar {
  margin-bottom: 20px;
}

.output-box {
  margin-top: 20px;
  text-align: right;
}

.select-page {
  width: 80px;
  margin: 0 5px;
}

.select-page-btn {
  margin-left: 10px;
}
</style>
